import { render, staticRenderFns } from "./CoverageItemQuery.vue?vue&type=template&id=6dabece0&scoped=true"
import script from "./CoverageItemQuery.vue?vue&type=script&lang=js"
export * from "./CoverageItemQuery.vue?vue&type=script&lang=js"
import style0 from "./CoverageItemQuery.vue?vue&type=style&index=0&id=6dabece0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dabece0",
  null
  
)

export default component.exports